
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("haBj0", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c8004ef4248570bd$export$6503ec6e8aabbaf; }, function (v) { return $c8004ef4248570bd$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $c8004ef4248570bd$export$f7ad0328861e2f03; }, function (v) { return $c8004ef4248570bd$export$f7ad0328861e2f03 = v; });
var $c8004ef4248570bd$export$6503ec6e8aabbaf;
var $c8004ef4248570bd$export$f7ad0328861e2f03;
"use strict";
var $c8004ef4248570bd$var$mapping = new Map();
function $c8004ef4248570bd$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c8004ef4248570bd$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c8004ef4248570bd$var$resolve(id) {
    var resolved = $c8004ef4248570bd$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c8004ef4248570bd$export$6503ec6e8aabbaf = $c8004ef4248570bd$var$register;
$c8004ef4248570bd$export$f7ad0328861e2f03 = $c8004ef4248570bd$var$resolve;

});

var $04702803382de879$exports = {};

(parcelRequire("haBj0")).register(new URL("", import.meta.url).toString(), JSON.parse('["c1MlR","index.736ef9a7.js","2kYCj","Instamart.71d5cec7.js"]'));


//# sourceMappingURL=index.runtime.cef0c56a.js.map
